import React from 'react'


import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  container: {
    maxWidth: '50%'
  },
  item: {
    textAlign: 'center',
    display: 'inline-block',
  },
}))

const Loading = ({
  color,
  message,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.item}>
          <CircularProgress 
            color={ color }
          />
          { 
            message && (
              <Typography
                variant='subtitle1'
                color={ color }
              >
                { message }
              </Typography>
            )
          }
        </div>
        
      </div>
    </div>
  )
}

Loading.defaultProps = {
  variant: 'subheading',
  color: 'primary',
  message: 'loading',
}

export default Loading